import React, {Component} from "react";
import PropTypes from 'prop-types';
import _ from "lodash";
import {NavLink} from "react-router-dom";

const propTypes = {
	icon: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	actions: PropTypes.array,
	stateNav: PropTypes.bool,
	modality: PropTypes.string,
	filterChange: PropTypes.func,
	filter: PropTypes.string,
	type: PropTypes.string,
	entity: PropTypes.string,
	changeStates: PropTypes.func,
	changeMuns: PropTypes.func
}

class Subnavigation extends Component {
	render() {
		let { icon, name, actions, stateNav, modality, agenciable, filter } = this.props;
		let states = this.stateList();
		let municipalities = this.municipalityList();
		return (<div className="subnavigation">
				<div className="level">
					<div className="level-item">
						<div className="subnav-section">
							<i className={`fa ${icon} has-text-inm-dark-purple`} />
							<p>{name}</p>
						</div>
					</div>

					{actions && _.map(actions, (slot, key) => {
						let item = this.subnavbarItem(slot);
						return <div className="level-item" key={`subnav-${key}`}>
							{item}
						</div>})
					}

					{(stateNav && stateNav === true) &&
					<div className="level-item subnav-states">
						<div className="field has-addons">
							<div className="control">
								<div className="select is-small is-dark">
									<select id="psn-projects" value={filter} onChange={(e) => this.props.filterChange(e)}>
										<option disabled>--- Tipo de proyecto ---</option>
										<option value="all_projects" defaultValue>Todas las instancias</option>
										<option value="registred" >Proyectos registrados</option>
										<option value="code" >Proyectos con folio</option>
										<option value="benefited" >Proyectos beneficiados</option>
									</select>
								</div>
							</div>

							{modality === 'modalidad-ii' ?
								<div className="field has-addons">
									<div className="control">
										<div className="select is-small is-dark">
											<select ref="stateNav-statesMun" value={agenciable.state} onChange={(field) => this.props.stateChange(field.target.value)}>
												<option value="">--- Estado ---</option>
												{_.map(states, (st, key) => {
													return <option value={st.agenciable_state_short} key={key}>{st.agenciable_state_name}</option>
												})}
											</select>
										</div>
									</div>
									<div className="control">
										<div className="select is-small is-dark">
											<select ref="stateNav-muns" onChange={(e) => this.props.changeMuns(e.target.value)} value={agenciable.municipality}>
												<option value="">--- Municipios ---</option>
												{_.map(municipalities, (mun, j) => {
													return <option value={mun.agenciable_slug} key={j}>{mun.agenciable_name}</option>
												})}
											</select>
										</div>
									</div>
								</div> :
								<div className="control">
									<div className="select is-small is-dark">
										<select ref="stateNav-states" onChange={(e) => this.props.changeStates(e.target.value)} value={agenciable.state}>
											<option>--- Estado ---</option>
											{_.map(states, (state, key) => {
												return <option value={state.agenciable_short} key={key}>{state.agenciable_name}</option>
											})}
										</select>
									</div>
								</div>}
						</div>
					</div>}
				</div>
			</div>);
	}

	subnavbarItem(item) {
		switch(item.type) {
			case 'button':
				return (<div className="subnav-actions">
					<p>
						<NavLink to={item.url} className="button is-small is-inm-purple">{item.name}</NavLink>
					</p>
				</div>)
			case 'search':
				return (<div className="subnav-actions">
					{item.element}
				</div>)
			case 'element':
				return (<div className="subnav-actions">
					{item.element}
				</div>)
			default:
				return (<div className="subnav-actions">
					<p>
						{item.name}
					</p>
				</div>)
		}
	}

	stateList(){
		const { modality, filter, agencies } = this.props;

		switch (filter) {
			case 'registred':
				if(modality !== 'modalidad-ii'){
					return _.sortBy(_.filter(agencies[modality], (o) => {return o.project_id}), ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(_.filter(agencies[modality], (o) => {return o.project_id}),'agenciable_state_id'), ['agenciable_state_name']);
				}
			case 'code':
				if(modality !== 'modalidad-ii'){
					return _.sortBy(_.filter(agencies[modality], (o) => {return o.project_code}), ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(_.filter(agencies[modality], (o) => {return o.project_code}),'agenciable_state_id'), ['agenciable_state_name']);
				}
			case 'benefited':
				if(modality !== 'modalidad-ii'){
					return _.sortBy(_.filter(agencies[modality], (o) => {return o.project_benefited === 1}), ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(_.filter(agencies[modality], (o) => {return o.project_benefited === 1}),'agenciable_state_id'), ['agenciable_state_name']);
				}
			default :
				if(modality !== 'modalidad-ii'){
					return _.sortBy(agencies[modality], ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(agencies[modality],'agenciable_state_id'), ['agenciable_state_name']);
				}
		}
	}

	municipalityList(){
		const {modality, agencies, filter, agenciable} = this.props;

		switch (filter) {
			case 'registred':
				return _.sortBy(_.filter(_.filter(agencies[modality], (o) => {return o.project_id}), {agenciable_state_short: agenciable.state}), ['agenciable_name'])
			case 'code':
				return _.sortBy(_.filter(_.filter(agencies[modality], (o) => {return o.project_code}), {agenciable_state_short: agenciable.state}), ['agenciable_name'])
			case 'benefited':
				return _.sortBy(_.filter(_.filter(agencies[modality], (o) => {return o.project_benefited === 1}), {agenciable_state_short: agenciable.state}), ['agenciable_name'])
			default :
				return _.sortBy(_.filter(agencies[modality], {agenciable_state_short: agenciable.state}), ['agenciable_name'])
		}
	}
}

Subnavigation.propTypes = propTypes;

export default Subnavigation;


// WEBPACK FOOTER //
// ./src/elements/navigation/subnavigation.jsx